// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2927":"db8d5e44bdef5e3b","3922":"b8a2f815f3889cfa"}[chunkId] + ".css";
};